__webpack_public_path__ = window.resourceBaseUrl + window.resourceBaseUrlAppPath + '/';



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 74
// module chunks = 2